module.exports = __webpack_public_path__ + "img/bottom.6a284b1c.png";